import { lazy } from "react"
import { Root } from "src/shared/components"
import PermissionRoute from "../permission-route"
import { Navigate } from "react-router-dom"
import CreateRole from "src/modules/system/roles/pages/CreateRole"
import UpdateRole from "src/modules/system/roles/pages/UpdateRole"
import AuditList from "src/modules/system/audit/pages/AuditList"
import AuditExecution from "src/modules/system/audit/pages/AuditExecution"
import LocationList from "src/modules/system/locations/pages/LocationList"
import PlatformFeeList from "src/modules/system/platform-fee-config/pages/platform-fee-list"
import RegisterList from "src/modules/system/register/pages/register-list"
import IntegrationsList from "src/modules/system/integrations/pages/integrations-list"
import IntegrationsCatalogue from "src/modules/system/integrations-hub/pages/catalogue"
import IntegrationDetail from "src/modules/system/integrations-hub/pages/detail"

const RoleList = lazy(() => import("src/modules/system/roles/pages/RoleList"))
const UsersList = lazy(() => import("src/modules/system/users/pages/UsersList"))
const Locations = lazy(() => import("src/modules/system/locations/pages/LocationList"))
const AdjustmentsList = lazy(() => import("src/modules/system/adjustment/pages/AdjustmentsList"))
const CreateAdjustment = lazy(() => import("src/modules/system/adjustment/pages/CreateAdjustment"))

const systemRoutes = {
  path: "system",
  element: <Root />,
  children: [
    {
      index: true,
      element: <Navigate to="system/users" />
    },
    {
      path: "users",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="system:users:read">
              <UsersList />
            </PermissionRoute>
          )
        }
      ]
    },
    { path: "locations", element: <Locations /> },
    {
      path: "roles",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="system:roles:read">
              <RoleList />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission="system:roles:read">
              <CreateRole />
            </PermissionRoute>
          )
        },
        {
          path: "update/:roleId",
          element: (
            <PermissionRoute permission="system:roles:read">
              <UpdateRole />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "adjustments",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="system:adjustment:read">
              <AdjustmentsList />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission="system:adjustment:create">
              <CreateAdjustment />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "audit",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="system:audit:read">
              <AuditList />
            </PermissionRoute>
          )
        },

        {
          path: "execution/:id",
          element: <AuditExecution />
        }
      ]
    },
    {
      path: "location",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="system:location:read">
              <LocationList />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "platform-fee-config",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="system:platform-fee:read">
              <PlatformFeeList />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "register",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="system:register-management:read">
              <RegisterList />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "integrations",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="system:integrations:read">
              <IntegrationsList />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "connected-apps",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="system:integrations:read">
              <IntegrationsCatalogue />
            </PermissionRoute>
          )
        },
        {
          path: ":connectionId",
          element: (
            <PermissionRoute permission="system:integrations:read">
              <IntegrationDetail />
            </PermissionRoute>
          )
        }
      ]
    }
  ]
}

export default systemRoutes
